module.exports = __webpack_public_path__ + "static/media/vegitables_53.9956eef5.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_53.csv
// module id = 639
// module chunks = 0